// Requests
import PostCall from "./CommonApi";

export default function GetCheckout(checkOutDetailsRequestObject) {
  let url = "/v1/ovra/transaction/v5/Checkout";
  let requestObject = 
    checkOutDetailsRequestObject;
  return PostCall(url, requestObject);
}
